import {
  HiringRequestData,
  hiringRequestDDValues,
  HiringRequestResponseData,
  PanelMemberFormValue,
} from '@interfaces/hiring-manager.model';
import { panelMemberOne, panelMemberTwo } from './hiring-request.config';

export function buildHiringRequestBody(
  formValues: any,
  jdFilePath: string,
  isEditMode: boolean,
  userProfile: any,
  hiringRequest: HiringRequestResponseData | null,
  hiringRequestId: number,
): HiringRequestData {
  const extractValue = (field: any) =>
    Array.isArray(field) ? field[0]?.value : field?.value;
  const allPanelMembers = [
    ...[panelMemberOne, panelMemberTwo]?.map((key, idx) => ({
      employeeId: extractValue(formValues[key]),
      panelAvailabilityTimezone: extractValue(formValues[`${key}Timezone`]),
      panelLevel: (idx + 1).toString(),
    })),
    ...(formValues.panelMembers || [])?.map((member: PanelMemberFormValue, idx: number) => ({
      employeeId: extractValue(member.panelMember),
      panelAvailabilityTimezone: extractValue(member.panelMemberTimezone),
      panelLevel: (idx + 3).toString(),
    })),
  ];
  const panelList = allPanelMembers.filter(
    (member) => member.employeeId && member.panelAvailabilityTimezone
  );
  return {
    lob: {
      lobId: extractValue(formValues.lineOfBusiness),
    },
    project: {
      projectId: extractValue(formValues.projectName),
    },
    jobTitle: formValues.jobTitle,
    location: formValues.jobLocation?.map(
      (loc: hiringRequestDDValues) => loc.value,
    ),
    numberOfPositions: formValues.numberOfPositions,
    leaderEmployeeId: formValues.dntLeader.value,
    yearsOfOverallExperience:
      formValues.overAllExp !== '' ? formValues.overAllExp : 0,
    yearsOfRelevantExperience: formValues.relExp !== '' ? formValues.relExp : 0,
    isPriority: formValues.priorityOptions?.value,
    desiredStartDate:
      formValues.startDate instanceof Date &&
      !isNaN(formValues.startDate.getTime())
        ? new Date(
            new Date(formValues.startDate).getTime() -
              new Date(formValues.startDate).getTimezoneOffset() * 60000,
          )
            .toISOString()
            .split('T')[0]
        : formValues.startDate ||
          hiringRequest?.desiredStartDate ||
          new Date().toISOString().split('T')[0],
    hiringSkills: [
      ...(formValues.mandatorySkills?.map((skill: hiringRequestDDValues) => ({
        categoryId: Number(skill.value),
        mandatorySkills: true,
        goodToHaveSkills:
          formValues.goodToHaveSkills?.some(
            (gthSkill: hiringRequestDDValues) => gthSkill.value === skill.value,
          ) || false,
      })) || []),
      ...(formValues.goodToHaveSkills
        ?.filter(
          (skill: hiringRequestDDValues) =>
            !formValues.mandatorySkills?.some(
              (mSkill: hiringRequestDDValues) => mSkill.value === skill.value,
            ),
        )
        ?.map((skill: hiringRequestDDValues) => ({
          categoryId: Number(skill.value),
          mandatorySkills: false,
          goodToHaveSkills: true,
        })) || []),
    ],
    additionalComments: formValues.comment ?? null,
    jobDescriptionFilePath: jdFilePath,
    hiringManager: {
      hiringManagerEmpId: extractValue(formValues.hiringManager),
    },
    hiringPanel: panelList,
    hiringVendors: formValues.vendors?.map((vendor: hiringRequestDDValues) => ({
      vendorId: Number(vendor.value),
    })),
    status: 'Open',
    hiringRequestId: isEditMode ? hiringRequestId : -1,
    createdBy: isEditMode ? hiringRequest?.createdBy : userProfile.email,
    updatedBy: isEditMode ? userProfile.email : null,
  };
}
